// Builds the event envelope (PRD §4.3). Identity rides on every event — no separate
// `identify` round-trip. We attach user_id + customer_id (the keys needed for
// traceability) but deliberately NOT email/username: those stay mappable from our own
// DB by user_id, keeping PII out of the event stream. Where they come from is identity.js.

import { config } from "./config"
import { identityIds } from "./identity"

// Page state, kept current by the router layer (see router.js). Falls back to
// window.location for events fired outside a tracked route change.
const page = { path: null, referrer: null, screen: null, domain: null }

export function setPage({ path, referrer, screen, domain }) {
    page.path = path ?? page.path
    page.referrer = referrer ?? page.referrer
    page.screen = screen ?? page.screen
    page.domain = domain ?? page.domain
}

function currentPath() {
    if (page.path) return page.path
    try { return window.location.pathname } catch { return null }
}

function viewport() {
    try { return `${window.innerWidth}x${window.innerHeight}` } catch { return null }
}

// Derive a coarse screen label from the path's first segment when the router hasn't set
// one (e.g. "/stock/detail" → "stock").
function currentScreen() {
    if (page.screen) return page.screen
    const p = currentPath()
    if (!p) return null
    const seg = p.split("/").filter(Boolean)[0]
    return seg || "home"
}

export function buildEnvelope(event, props, session, ts) {
    return {
        app: config.app,
        event,
        ts,
        session_id: session.sessionId,
        seq: session.seq,
        tab_id: session.tabId,
        ...identityIds(),
        app_version: config.appVersion,
        context: {
            path: currentPath(),
            referrer: page.referrer,
            screen: currentScreen(),
            domain: page.domain,
            viewport: viewport(),
        },
        props: props || {},
    }
}
